import { render, staticRenderFns } from "./MallSwiper.vue?vue&type=template&id=560089d2&scoped=true&"
import script from "./MallSwiper.vue?vue&type=script&lang=ts&"
export * from "./MallSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./MallSwiper.vue?vue&type=style&index=0&id=560089d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560089d2",
  null
  
)

export default component.exports